// src/services/authService.js
import axios from 'axios';

// Define the base URL for the API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Create an axios instance
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    // Don't include credentials by default since the server doesn't support it
    withCredentials: false,
});

// Authentication service functions
const AuthService = {
    // Check if user is authenticated
    checkStatus: () => {
        return apiClient.get('/auth/status');
    },

    // Login with email and password
    login: (email, password) => {
        const formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);

        return apiClient.post('/auth/login', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    // Verify MFA code
    verifyMfa: (mfaCode) => {
        const formData = new FormData();
        formData.append('mfa_code', mfaCode);

        return apiClient.post('/auth/mfa', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    // Logout
    logout: () => {
        return apiClient.post('/auth/logout');
    }
};

export default AuthService;